export const WHITE_LABEL_HELP_URL =
  'https://help.hostfully.com/en/articles/3049073-white-label-your-hostfully-sites';
